import { reactive } from 'vue';
import strapiApi from '@/services/strapiApi';

// Roles that have management rights (import, media upload, fabric editor)
const MANAGE_ROLES = ['Admin']

export const userStore = reactive({
  currentUser: null,
  users: [],

  loadCurrentUser() {
    const user = localStorage.getItem('user');
    if (user) {
      this.currentUser = JSON.parse(user);
    }
  },

  setCurrentUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
    this.currentUser = user;
  },

  login(user, jwt) {
    localStorage.setItem('jwt', jwt);
    this.setCurrentUser(user);
  },

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('jwt');
    this.currentUser = null;
  },

  get canManage() {    
    const roleName = this.currentUser?.role?.name ?? ''
    return MANAGE_ROLES.some(r => roleName.toLowerCase() === r.toLowerCase())
  },

  async fetchCurrentUser() {
    try {
      const response = await strapiApi.me();
      this.setCurrentUser(response.data);
    } catch (error) {
      console.error('Error fetching current user:', error);
    }
  },

  async fetchUsers() {
    try {
      const response = await strapiApi.getUsers();
      this.users = response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  },
});
